import {
	SET_THERMOBOX_REPORT_INFO,
	SET_IS_THERMOBOX_REPORT_INFO_LOADING,
	SET_IS_THERMOBOX_REPORT_CREATING,
	SET_IS_THERMOBOX_REPORT_UPDATING,
	SET_IS_THERMOBOX_REPORT_DELETING,
	SET_THERMOBOXES,
	SET_IS_THERMOBOXES_LOADING,
	SET_MODES,
	SET_IS_MODES_LOADING,
	RESET_STATE,
	SET_ICEPACKS,
	SET_IS_ICEPACKS_LOADING,
	GET_THERMOBOX_REPORT_DOCS,
	SET_THERMOBOX_REPORT_DOCS,
	POST_THERMOBOX_REPORT_DOCS,
	SET_THERMOBOX_REPORT_DOCS_ERRORS,
	SET_DOCS_FILES,
	SET_IS_THERMOBOX_REPORT_DOCS_LOADING,
	SET_IS_THERMOBOX_REPORT_DOCS_SENDING,
	GET_THERMOBOX_REPORT_FORM,
	SET_THERMOBOX_REPORT_FORM,
} from './actions';

export const initialState = {
	thermoboxReportInfo: null,
	isThermoboxReportInfoLoading: false,
	isThermoboxReportCreating: false,
	isThermoboxReportUpdating: false,
	isThermoboxReportDeleting: false,
	thermoboxes: [],
	isThermoboxesLoading: false,
	modes: [],
	isModesLoading: false,
	icepacks: [],
	isIcepacksLoading: false,
	thermoboxReportDocs: [],
	thermoboxReportDocsFormErrors: {},
	files: {},
	isThermoboxReportDocsLoading: false,
	isThermoboxReportDocsSending: false,
	thermoboxReportForm: [],
};

const thermoboxReportModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_THERMOBOX_REPORT_INFO:
			return { ...state, thermoboxReportInfo: payload };
		case SET_IS_THERMOBOX_REPORT_INFO_LOADING:
			return { ...state, isThermoboxReportInfoLoading: payload };
		case SET_IS_THERMOBOX_REPORT_CREATING:
			return { ...state, isThermoboxReportCreating: payload };
		case SET_IS_THERMOBOX_REPORT_UPDATING:
			return { ...state, isThermoboxReportUpdating: payload };
		case SET_IS_THERMOBOX_REPORT_DELETING:
			return { ...state, isThermoboxReportDeleting: payload };
		case SET_THERMOBOXES:
			return { ...state, thermoboxes: payload };
		case SET_IS_THERMOBOXES_LOADING:
			return { ...state, isThermoboxesLoading: payload };
		case SET_MODES:
			return { ...state, modes: payload };
		case SET_IS_MODES_LOADING:
			return { ...state, isModesLoading: payload };
		case SET_ICEPACKS:
			return { ...state, icepacks: payload };
		case SET_IS_ICEPACKS_LOADING:
			return { ...state, isIcepacksLoading: payload };
		case GET_THERMOBOX_REPORT_DOCS:
			return {
				...state,
				thermoboxReportDocsFormErrors: {},
			};
		case SET_THERMOBOX_REPORT_DOCS:
			return {
				...state,
				thermoboxReportDocs: payload,
			};
		case POST_THERMOBOX_REPORT_DOCS:
			return {
				...state,
			};
		case SET_THERMOBOX_REPORT_DOCS_ERRORS:
			return {
				...state,
				thermoboxReportDocsFormErrors: payload,
			};
		case SET_DOCS_FILES:
			return {
				...state,
				files: payload,
			};
		case SET_IS_THERMOBOX_REPORT_DOCS_LOADING:
			return { ...state, isThermoboxReportDocsLoading: payload };
		case SET_IS_THERMOBOX_REPORT_DOCS_SENDING:
			return { ...state, isThermoboxReportDocsSending: payload };
		case GET_THERMOBOX_REPORT_FORM:
			return {
				...state,
			};
		case SET_THERMOBOX_REPORT_FORM:
			return {
				...state,
				thermoboxReportForm: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default thermoboxReportModalReducer;
